import { getSettingInsiderChurnedMessaging } from "@faire/retailer/settings/getSettingInsiderChurnedMessaging";

import { useInsiderState } from "./useInsiderState";

export const useShowEligibleInsiderMessaging = () => {
  const { isInsiderEligible, isInsiderCancelled } = useInsiderState();
  const showEligibleInsiderMessaging = getSettingInsiderChurnedMessaging()
    ? isInsiderEligible || isInsiderCancelled
    : isInsiderEligible && !isInsiderCancelled;

  return { showEligibleInsiderMessaging };
};
